import SvgIcon from "../../SvgIcon.jsx";
import ShieldUserIcon from "../../../images/remixicons/System/shield-user-line.js";

export default function AdministratorOnlyIcon() {
    return <span aria-hidden="true" className="h-3.5 w-3.5 shrink-0 [&>div]:h-full [&>div]:w-full [&>div>svg]:h-full [&>div>svg]:w-full">
        <SvgIcon source={ShieldUserIcon}/>
    </span>;
}
